module.exports = __webpack_public_path__ + "img/56.957414be.jpg";